import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router'
import PageMeta from '../../components/common/PageMeta'
import AuthLayout from './AuthPageLayout'
import ResetPasswordConfirmForm from '../../features/auth/ResetPasswordConfirmForm'

export default function ResetPasswordConfirm() {
  const { uid, token } = useParams<{ uid: string; token: string }>()
  const navigate = useNavigate()

  useEffect(() => {
    // Verificar se os parâmetros necessários estão presentes
    if (!uid || !token) {
      navigate('/reset-password', { replace: true })
    }
  }, [uid, token, navigate])

  if (!uid || !token) {
    return null // Redirect será feito pelo useEffect
  }

  return (
    <>
      <PageMeta
        title="Nova Senha | Optimus - Plataforma de IA Multi-Agente"
        description="Defina sua nova senha da plataforma Optimus da MDi"
      />
      <AuthLayout>
        <ResetPasswordConfirmForm />
      </AuthLayout>
    </>
  )
}
